import { find, filter, intersection } from 'lodash';
import { createSelector } from 'reselect';
import { ConversationMessageType } from 'constants/conversation';
import { ApplicableTransactionAction, AdditionalTransactionAction } from 'constants/transaction';
import { Translation } from 'constants/translation';
import { PhoneRequirement } from 'constants/shipping-contact';
import * as shippingContactSelectors from 'state/shipping-contact/selectors';
import { stateName } from './constants';

const localState = state => state[stateName];

export const getMessageById = (state, id) => {
  var _localState$conversat;

  const messages = filter((_localState$conversat = localState(state).conversation) === null || _localState$conversat === void 0 ? void 0 : _localState$conversat.messages, message => message.entityType === ConversationMessageType.Message).map(message => message.message);
  return find(messages, {
    id
  });
};
export const getUiState = createSelector(localState, _ref => {
  let {
    ui
  } = _ref;
  return ui;
});
export const getIsTranslated = state => {
  var _localState$conversat2;

  return (_localState$conversat2 = localState(state).conversation) === null || _localState$conversat2 === void 0 ? void 0 : _localState$conversat2.isTranslated;
};
export const getConversation = state => localState(state).conversation;
export const getConversationUiState = state => localState(state).ui.getConversation.uiState;
export const getConversationUi = state => localState(state).ui.getConversation;
export const getTransaction = state => localState(state).transaction;
export const getConversationTransaction = state => {
  var _localState$conversat3;

  return (_localState$conversat3 = localState(state).conversation) === null || _localState$conversat3 === void 0 ? void 0 : _localState$conversat3.transaction;
};
export const getTransactionUiState = state => localState(state).ui.getTransaction.uiState;
export const getModeratedItems = state => {
  var _localState$conversat4;

  return (_localState$conversat4 = localState(state).conversation) === null || _localState$conversat4 === void 0 ? void 0 : _localState$conversat4.moderatedItems;
};
export const getTransactionId = state => {
  var _localState$conversat5;

  return (_localState$conversat5 = localState(state).conversation) === null || _localState$conversat5 === void 0 ? void 0 : _localState$conversat5.transactionId;
};
export const getSuggestedMessages = state => {
  var _localState$conversat6;

  return (_localState$conversat6 = localState(state).conversation) === null || _localState$conversat6 === void 0 ? void 0 : _localState$conversat6.suggestedMessages;
};
export const getConversationId = state => {
  var _localState$conversat7;

  return (_localState$conversat7 = localState(state).conversation) === null || _localState$conversat7 === void 0 ? void 0 : _localState$conversat7.id;
};
export const getOppositeUser = state => {
  var _localState$conversat8;

  return (_localState$conversat8 = localState(state).conversation) === null || _localState$conversat8 === void 0 ? void 0 : _localState$conversat8.oppositeUser;
};
export const getOppositeUserId = state => {
  var _localState$conversat9, _localState$conversat10;

  return (_localState$conversat9 = localState(state).conversation) === null || _localState$conversat9 === void 0 ? void 0 : (_localState$conversat10 = _localState$conversat9.oppositeUser) === null || _localState$conversat10 === void 0 ? void 0 : _localState$conversat10.id;
};
export const getMessages = state => {
  var _localState$conversat11;

  return (_localState$conversat11 = localState(state).conversation) === null || _localState$conversat11 === void 0 ? void 0 : _localState$conversat11.messages;
};
export const getTranslationType = state => {
  var _localState$conversat12, _localState$conversat13;

  return (_localState$conversat12 = (_localState$conversat13 = localState(state).conversation) === null || _localState$conversat13 === void 0 ? void 0 : _localState$conversat13.translationType) !== null && _localState$conversat12 !== void 0 ? _localState$conversat12 : Translation.None;
};
export const getIsReadByOppositeUser = state => {
  var _localState$conversat14;

  return (_localState$conversat14 = localState(state).conversation) === null || _localState$conversat14 === void 0 ? void 0 : _localState$conversat14.isReadByOppositeUser;
};
export const getIsSidebarOpen = state => localState(state).ui.isSidebarOpen;
export const getSendMessageUi = state => localState(state).ui.sendMessage;
export const getSendMessageUiState = createSelector(getSendMessageUi, ui => ui.uiState);
export const getSendMessageUiError = createSelector(getSendMessageUi, ui => ui.error);
export const getTrackingJourneySummary = state => localState(state).tracking;
export const getTrackingJourneySummaryUi = state => localState(state).ui.trackingJourneySummary;
export const getTrackingJourneySummaryUiState = createSelector(getTrackingJourneySummaryUi, ui => ui.uiState);
export const getShipmentInstructions = state => localState(state).shipmentInstructions;
export const getFirstTransactionItem = state => {
  var _localState$conversat15;

  return (_localState$conversat15 = localState(state).conversation) === null || _localState$conversat15 === void 0 ? void 0 : _localState$conversat15.item;
};
export const getFirstTransactionItemPhoto = createSelector(getFirstTransactionItem, item => item === null || item === void 0 ? void 0 : item.photo);
export const getComplaintId = createSelector(getTransaction, transaction => transaction === null || transaction === void 0 ? void 0 : transaction.complaintId);
export const getShippingLabelUrl = createSelector(getTransaction, transaction => {
  var _transaction$shipment;

  return transaction === null || transaction === void 0 ? void 0 : (_transaction$shipment = transaction.shipment) === null || _transaction$shipment === void 0 ? void 0 : _transaction$shipment.labelUrl;
});
export const getSellerAddressId = createSelector(getTransaction, transaction => {
  var _transaction$seller, _transaction$seller$d;

  return transaction === null || transaction === void 0 ? void 0 : (_transaction$seller = transaction.seller) === null || _transaction$seller === void 0 ? void 0 : (_transaction$seller$d = _transaction$seller.defaultAddress) === null || _transaction$seller$d === void 0 ? void 0 : _transaction$seller$d.id;
});
export const getTransactionShipmentPrice = createSelector(getTransaction, transaction => {
  var _transaction$buyerDeb;

  return transaction === null || transaction === void 0 ? void 0 : (_transaction$buyerDeb = transaction.buyerDebit) === null || _transaction$buyerDeb === void 0 ? void 0 : _transaction$buyerDeb.shipmentPrice;
});
export const getTransactionShipmentCurrency = createSelector(getTransaction, transaction => {
  var _transaction$buyerDeb2;

  return transaction === null || transaction === void 0 ? void 0 : (_transaction$buyerDeb2 = transaction.buyerDebit) === null || _transaction$buyerDeb2 === void 0 ? void 0 : _transaction$buyerDeb2.currency;
});
export const getTransactionPrice = createSelector(getConversationTransaction, transaction => transaction === null || transaction === void 0 ? void 0 : transaction.offer.price); // TODO: remove this selector and dependency on it.

export const getTransactionCurrency = createSelector(getConversationTransaction, transaction => transaction === null || transaction === void 0 ? void 0 : transaction.offer.price.currencyCode);
export const getApplicableTransactionActions = createSelector(getConversationTransaction, transaction => {
  if (!transaction) return undefined;
  return intersection(transaction.availableActions, Object.values(ApplicableTransactionAction));
});
export const getAditionalTransactionActions = createSelector(getConversationTransaction, transaction => {
  if (!transaction) return undefined;
  return intersection(transaction.availableActions, Object.values(AdditionalTransactionAction));
});
export const getTransactionStatus = createSelector(getConversationTransaction, transaction => transaction === null || transaction === void 0 ? void 0 : transaction.status);
export const getTransactionShipmentDefaultAddress = createSelector(getTransaction, transaction => {
  var _transaction$seller2;

  return transaction === null || transaction === void 0 ? void 0 : (_transaction$seller2 = transaction.seller) === null || _transaction$seller2 === void 0 ? void 0 : _transaction$seller2.defaultAddress;
});
export const getTransactionShipmentBuyerAddress = createSelector(getTransaction, transaction => transaction === null || transaction === void 0 ? void 0 : transaction.buyer.defaultAddress);
export const getSellerCountryCode = createSelector(getTransaction, transaction => {
  var _transaction$seller3;

  return transaction === null || transaction === void 0 ? void 0 : (_transaction$seller3 = transaction.seller) === null || _transaction$seller3 === void 0 ? void 0 : _transaction$seller3.countryCode;
});
export const getEnterTrackingCodeUi = createSelector(getUiState, ui => ui.enterTrackingCode);
export const getEnterTrackingCodeUiState = createSelector(getEnterTrackingCodeUi, ui => ui.uiState);
export const getEnterTrackingCodeUiError = createSelector(getEnterTrackingCodeUi, ui => ui.error);
export const getMarkAsShippedUi = createSelector(getUiState, ui => ui.markAsShipped);
export const getMarkAsShippedUiState = createSelector(getMarkAsShippedUi, ui => ui.uiState);
export const getMarkAsShippedUiError = createSelector(getMarkAsShippedUi, ui => ui.error);
export const getSelectedShippingDate = createSelector(getUiState, ui => ui.selectedShippingDate);
export const getShipmentInstructionsCarrier = createSelector(getShipmentInstructions, shipmentInstructions => shipmentInstructions === null || shipmentInstructions === void 0 ? void 0 : shipmentInstructions.carrier);
export const getDropOffTypeMethods = createSelector(getTransaction, transaction => {
  var _transaction$shipment2;

  return transaction === null || transaction === void 0 ? void 0 : (_transaction$shipment2 = transaction.shipment) === null || _transaction$shipment2 === void 0 ? void 0 : _transaction$shipment2.packageType.dropOffTypes;
});
export const getSelectedDropOffTypeMethod = createSelector(getShipmentInstructions, shipmentInstructions => shipmentInstructions === null || shipmentInstructions === void 0 ? void 0 : shipmentInstructions.dropOffType);
export const getSelectedDropOffTypeUiState = createSelector(getUiState, ui => ui.selectDropOffType);
export const getSelectedDropOffTypeId = createSelector(getSelectedDropOffTypeUiState, ui => ui.selectedDropOffTypeId);
export const getDropOffTypeSubmitUiState = createSelector(getSelectedDropOffTypeUiState, ui => ui.isSubmitEnabled);
export const getRecipientId = state => localState(state).recipientId;
export const getSelectedDropOffTypeMethodUi = createSelector(getUiState, ui => ui.selectDropOffType);
export const getSelectedDropOffTypeMethodUiState = createSelector(getSelectedDropOffTypeMethodUi, ui => ui.uiState);
export const getSelectedDropOffTypeMethodUiError = createSelector(getSelectedDropOffTypeMethodUi, ui => ui.error);
export const getLabelFormatDetails = createSelector(getShipmentInstructions, shipmentInstructions => shipmentInstructions === null || shipmentInstructions === void 0 ? void 0 : shipmentInstructions.labelFormatDetails);
export const getDigitalLabel = state => localState(state).digitalLabel;
export const getCreateOfferUi = createSelector(getUiState, ui => ui.createOffer);
export const getCreateOfferUiState = createSelector(getCreateOfferUi, ui => ui.uiState);
export const getCreateOfferUiError = createSelector(getCreateOfferUi, ui => ui.error);
export const getAcceptOfferUi = createSelector(getUiState, ui => ui.acceptOffer);
export const getAcceptOfferUiState = createSelector(getAcceptOfferUi, ui => ui.uiState);
export const getAcceptOfferUiError = createSelector(getAcceptOfferUi, ui => ui.error);
export const getRejectOfferUi = createSelector(getUiState, ui => ui.rejectOffer);
export const getRejectOfferUiState = createSelector(getRejectOfferUi, ui => ui.uiState);
export const getRejectOfferUiError = createSelector(getRejectOfferUi, ui => ui.error);
export const getCourierPickUpDatesUi = createSelector(getUiState, ui => ui.getCourierPickUpDates);
export const getCourierPickUpDatesUiState = createSelector(getCourierPickUpDatesUi, ui => ui.uiState);
export const getCourierPickUpDatesUiError = createSelector(getCourierPickUpDatesUi, ui => ui.error);
export const getOfferRequestOptions = state => localState(state).offerRequestOptions;
export const getOfferPriceSuggestions = createSelector(getOfferRequestOptions, offerRequestOptions => (offerRequestOptions === null || offerRequestOptions === void 0 ? void 0 : offerRequestOptions.offerSuggestions) || []);
export const getPreselectedOfferPriceSuggestion = createSelector(getOfferPriceSuggestions, offerPriceSuggestions => offerPriceSuggestions[0]);
export const getTransactionUserSide = createSelector(getConversationTransaction, transaction => transaction === null || transaction === void 0 ? void 0 : transaction.userSide);
export const getSellerPhoneRequirement = createSelector(getTransaction, transaction => {
  var _transaction$shipment3, _transaction$shipment4;

  return transaction === null || transaction === void 0 ? void 0 : (_transaction$shipment3 = transaction.shipment) === null || _transaction$shipment3 === void 0 ? void 0 : (_transaction$shipment4 = _transaction$shipment3.packageType) === null || _transaction$shipment4 === void 0 ? void 0 : _transaction$shipment4.sellerPhoneRequirement;
});
export const getBuyerPhoneRequirement = createSelector(getTransaction, transaction => {
  var _transaction$shipment5;

  return transaction === null || transaction === void 0 ? void 0 : (_transaction$shipment5 = transaction.shipment) === null || _transaction$shipment5 === void 0 ? void 0 : _transaction$shipment5.packageType.buyerPhoneRequirement;
});
export const getIsSellerShippingContactDisabled = createSelector(getSellerPhoneRequirement, requirement => !requirement || requirement === PhoneRequirement.Disabled);
export const getIsBuyerShippingContactDisabled = createSelector(getBuyerPhoneRequirement, requirement => !requirement || requirement === PhoneRequirement.Disabled);
export const getIsSellerShippingContactCompleted = createSelector(getSellerPhoneRequirement, shippingContactSelectors.getSellerPhoneNumber, (requirement, sellerPhoneNumber) => !(requirement === PhoneRequirement.Mandatory && !sellerPhoneNumber));
export const getIsBuyerShippingContactCompleted = createSelector(getBuyerPhoneRequirement, shippingContactSelectors.getBuyerPhoneNumber, (requirement, buyerPhoneNumber) => !(requirement === PhoneRequirement.Mandatory && !buyerPhoneNumber));
export const getIsReplyAllowed = state => {
  var _localState$conversat16;

  return !!((_localState$conversat16 = localState(state).conversation) !== null && _localState$conversat16 !== void 0 && _localState$conversat16.isReplyAllowed);
};
export const getShipmentId = createSelector(getConversationTransaction, transaction => {
  var _transaction$shipment6;

  return transaction === null || transaction === void 0 ? void 0 : (_transaction$shipment6 = transaction.shipment) === null || _transaction$shipment6 === void 0 ? void 0 : _transaction$shipment6.id;
});
export const getShipmentStatus = createSelector(getConversationTransaction, transaction => {
  var _transaction$shipment7;

  return transaction === null || transaction === void 0 ? void 0 : (_transaction$shipment7 = transaction.shipment) === null || _transaction$shipment7 === void 0 ? void 0 : _transaction$shipment7.status;
});
export const getShipmentLabelType = createSelector(getTransaction, transaction => {
  var _transaction$shipment8;

  return transaction === null || transaction === void 0 ? void 0 : (_transaction$shipment8 = transaction.shipment) === null || _transaction$shipment8 === void 0 ? void 0 : _transaction$shipment8.shipmentLabelType;
});
export const getActiveGenerateLabelModal = state => localState(state).activeModal;
export const getDropOffPrintIconDetails = createSelector(getShipmentInstructions, shipmentInstructions => {
  var _shipmentInstructions;

  return shipmentInstructions === null || shipmentInstructions === void 0 ? void 0 : (_shipmentInstructions = shipmentInstructions.dropOffType) === null || _shipmentInstructions === void 0 ? void 0 : _shipmentInstructions.dropOffTypeMeta.dropOffPrintIcon;
});
export const getIsPickUpDateShown = createSelector(getShipmentInstructions, shipmentInstructions => {
  var _shipmentInstructions2;

  return shipmentInstructions === null || shipmentInstructions === void 0 ? void 0 : (_shipmentInstructions2 = shipmentInstructions.dropOffType) === null || _shipmentInstructions2 === void 0 ? void 0 : _shipmentInstructions2.pickUpDateShown;
});
export const getIsPickUpTimeShown = createSelector(getShipmentInstructions, shipmentInstructions => {
  var _shipmentInstructions3;

  return shipmentInstructions === null || shipmentInstructions === void 0 ? void 0 : (_shipmentInstructions3 = shipmentInstructions.dropOffType) === null || _shipmentInstructions3 === void 0 ? void 0 : _shipmentInstructions3.pickUpTimeShown;
});
export const getReturnShippingOption = state => localState(state).returnShippingOption;
export const getSelectedCourierPickUpDate = createSelector(getCourierPickUpDatesUi, ui => ui.selectedCourierPickUpDate);
export const getSelectedCourierPickUpTime = createSelector(getCourierPickUpDatesUi, ui => ui.selectedCourierPickUpTime);
export const getCourierPickUpDates = state => localState(state).courierPickupDates;
export const getDigitalLabelTypes = createSelector(getTransaction, transaction => {
  var _transaction$shipment9;

  return transaction === null || transaction === void 0 ? void 0 : (_transaction$shipment9 = transaction.shipment) === null || _transaction$shipment9 === void 0 ? void 0 : _transaction$shipment9.digitalLabelTypes;
});
export const getDigitalLabelTypesUi = createSelector(getUiState, ui => ui.selectLabelType);
export const getDigitalLabelTypeId = createSelector(getDigitalLabelTypesUi, ui => ui.selectedLabelType);
export const getDigitalLabelTypesUiState = createSelector(getDigitalLabelTypesUi, ui => ui.isSubmitEnabled);
export const getIsHarassmentWarningModalOpen = state => localState(state).ui.harassmentWarning.isModalOpen;
export const getWasHarassmentWarningOpen = state => localState(state).ui.harassmentWarning.wasModalOpen;
export const getScoredHarassmentMessage = state => localState(state).ui.harassmentWarning.scoredMessage;
export const getScoredHarassmentMessageCorrelationId = state => localState(state).ui.harassmentWarning.scoredHarassmentMessageCorrelationId;
export const getIsEmailSharingModalVisible = state => localState(state).ui.isEmailSharingModalVisible;
export const getShippingInstructions = state => localState(state).shippingInstructions;
export const getIsItemVerified = createSelector(getConversationTransaction, transaction => transaction === null || transaction === void 0 ? void 0 : transaction.isItemVerified);
export const getTransactionOfflineVerification = createSelector(getTransaction, transaction => transaction === null || transaction === void 0 ? void 0 : transaction.offlineVerification);
export const getConversationTransactionId = createSelector(getTransaction, transaction => transaction === null || transaction === void 0 ? void 0 : transaction.id);